import type { BookingSummaryData, BookingSummaryLabels } from '../../types';

import styles from './bookingSummary.module.css';

export interface BookingSummaryProps {
  data: BookingSummaryData;
  labels: BookingSummaryLabels;
}

const DetailRow = ({ label, value }: { label: string; value?: string }) =>
  value ? (
    <div className={styles.detailRow}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  ) : null;

const BookingSummary = ({ data, labels }: BookingSummaryProps) => {
  const hasTrainHeader = Boolean(data.departTime || data.arriveTime);
  const stations = [data.fromStation, data.toStation].filter(
    (station): station is string => Boolean(station)
  );
  const route = stations.length > 0 ? stations.join(' → ') : undefined;
  const quantities = data.quantities?.join(' ');

  return (
    <section className={styles.card}>
      {hasTrainHeader && (
        <div className={styles.trainRow}>
          <div className={styles.trainTime}>
            <span className={styles.time}>{data.departTime}</span>
            <span className={styles.station}>{data.fromStation}</span>
          </div>
          <div className={styles.middle}>
            <span className={styles.meta}>{data.duration}</span>
            <div className={styles.line} />
            <span className={styles.meta}>{data.trainName}</span>
          </div>
          <div className={styles.trainTime}>
            <span className={styles.time}>{data.arriveTime}</span>
            <span className={styles.station}>{data.toStation}</span>
          </div>
        </div>
      )}

      {hasTrainHeader && <div className={styles.divider} />}
      <div className={styles.details}>
        <h2 className={styles.ticketName}>{data.ticketName}</h2>
        <DetailRow label={labels.route} value={route} />
        <DetailRow label={labels.travelDate} value={data.travelDate} />
        <DetailRow label={labels.quantities} value={quantities} />
        <DetailRow label={labels.trainType} value={data.trainType} />
        <DetailRow label={labels.seatClass} value={data.seatClass} />
        <DetailRow label={labels.seatPreference} value={data.seatPreference} />
      </div>
    </section>
  );
};

export default BookingSummary;
